import { createFileRoute } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { CreatorDetailPage } from '@/features/creators';
import { formatDocumentTitle } from '@/lib/document-title';

/** One creator — `/marketing/creators/{id}` (its own screen, not nested in the list). */
export const Route = createFileRoute('/_auth/$orgId/marketing/creators_/$creatorId')({
  component: CreatorRoute,
});

function CreatorRoute() {
  const { orgId, creatorId } = Route.useParams();
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Creator', 'Marketing')}</title>
      </Helmet>
      <CreatorDetailPage routeOrgId={orgId} creatorId={creatorId} />
    </>
  );
}
